import { Route, Switch } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import PropTypes from 'prop-types';
import { GiCakeSlice } from 'react-icons/gi';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { useSpotlightActions } from '../../AppSpotlight';
import { useHistory } from 'react-router';

MenuManager.RegisterItem({
	parent: 'content',
	key: 'recipes',
	path: '/recipes',
	name: 'Рецепты',
	icon: <GiCakeSlice />,
	acl: 'recipes',
	position: 7
});

function RecipesRoute (props) {
	const basePath = props.path || '/recipes';
	const getPath = (path = '') => `${basePath}${path}`;

	const history = useHistory();
	useSpotlightActions([{
		id: 'recipes.page',
		title: 'Рецепты',
		icon: <GiCakeSlice />,
		onTrigger: () => history.push(getPath())
	}, {
		id: 'recipes.categories',
		title: 'Категории рецептов',
		icon: <GiCakeSlice />,
		onTrigger: () => history.push(getPath('/recipes'))
	}]);

	const List = useLoadComponent(() => import('./List').then((e) => e.NewsListPage), {
		basePath
	});

	const Edit = useLoadComponent(() => import('./Edit').then((m) => m.EditRecipes), {
		basePath
	});

	const Categories = useLoadComponent(() => import('./Categories/CategoriesRoute').then((e) => e.CategoriesRoute), {
		basePath,
		path: getPath('/categories')
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					path={getPath('/categories')}
					component={Categories}
				/>
				<Route
					exact
					path={getPath('/:id')}
					component={Edit}
				/>
			</Switch>
		</>
	);
}

RecipesRoute.propTypes = {
	path: PropTypes.string
};

export { RecipesRoute };
